import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateCacheService {
  private cache: Map<string, any> = new Map<string, any>();

  constructor() { }

  // Save an item to the cache
  set(key: string, value: any): void {
    this.cache.set(key, value);
  }

  // Get an item from the cache
  get<T>(key: string): T | null {
    if (this.cache.has(key)) {
      return this.cache.get(key) as T;
    }
    return null;
  }

  // Delete an item from the cache
  delete(key: string): void {
    this.cache.delete(key);
  }

  // Clear the entire cache
  clear(): void {
    this.cache.clear();
  }
}
